import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logEvent } from '../utils/analytics';
import './Navbar.css';

function Navbar({ onTryNowClick }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    logEvent('Navigation', 'navbar_hamburger_toggled', {
      is_open: !isMenuOpen,
    });
  };

  const handleLogoClick = () => {
    logEvent('Navigation', 'navbar_logo_clicked');
    navigate('/');
  };

  const scrollToSection = (sectionId) => {
    logEvent('Navigation', 'navbar_link_clicked', {
      link_target: sectionId,
    });
    // If not on homepage, navigate to homepage first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Already on homepage, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src="/logo.svg" alt="S.C.A.L.P.E.L. Logo" />
        </div>

        <div className="navbar-menu-wrapper">
          <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
            <a href="#features" className="navbar-link" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>
              Features
            </a>
            <a href="#use-cases" className="navbar-link" onClick={(e) => { e.preventDefault(); scrollToSection('use-cases'); }}>
              Use Cases
            </a>
            <a href="https://docplix.com" className="navbar-link" target="_blank" rel="noopener noreferrer">
              About DocPlix
            </a>
            <a href="/contact" className="navbar-link" onClick={(e) => { e.preventDefault(); navigate('/contact'); setIsMenuOpen(false); }}>
              Contact Us
            </a>
          </div>
          <button className="navbar-btn" onClick={() => {
            logEvent('Landing Page', 'navbar_cta_clicked', {
              button_text: 'Start Learning Free',
            });
            onTryNowClick();
          }}>
            <span>Start Learning Free</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7 7H17V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="navbar-hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
